import React, { useState } from "react";
import QuizItem from "./QuizItem";
import { Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { values } from "lodash";
import FullNameAndEmail from "./FullNameAndEmail";
import { subscribeContact } from "../services/subscribeContact";
import styled from "@emotion/styled";
import cover from "../assets/img/cover.jpg";
import Card from "@material-ui/core/Card";
import ResponseFromServer from "./ResponseFromServer";
import Dialog from "./Dialog";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import WhatsAppClick from "./WhatsAppClick";

const questions = [
  {
    id: "1",
    questionText: "איפה הוקם הסטודיו?",
    answerOptions: [
      { answerText: "קרית שמונה", isCorrect: false },
      { answerText: "אפרת", isCorrect: false },
      { answerText: "קרני שומרון", isCorrect: true },
      { answerText: "ראש העין", isCorrect: false },
    ],
  },
  {
    id: "2",
    questionText: "כמה שמלות הנקה יש באתר?",
    answerOptions: [
      { answerText: "3", isCorrect: false },
      { answerText: "35", isCorrect: true },
      { answerText: "22", isCorrect: false },
      { answerText: "68", isCorrect: false },
    ],
  },
  {
    id: "3",
    questionText:
      "מה מהשמות הבאים הוא שם של השמלה הכי נמכרת מהקולקציה האחרונה ?",
    answerOptions: [
      { answerText: "שירה - המעצבת של הסטודיו", isCorrect: false },
      { answerText: "אופק - מנהלת הסטודיו", isCorrect: false },
      { answerText: "רננה - מנהלת תוכן", isCorrect: false },
      { answerText: "רז - נולדה רגע לפני יציאת הקולקציה", isCorrect: true },
    ],
  },
];

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
  },
}));

const Home = () => {
  const classes = useStyles();
  const [answers, setAnswers] = useState({ 1: false, 2: false, 3: false });
  const [userDetails, setUserDetails] = useState(null);
  const [cleanForm, setCleanForm] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isResponseFromServer, setIsResponseFromServer] = useState(false);

  const handleChange = (id, isCorrect) => {
    setAnswers((answers) => ({ ...answers, [id]: isCorrect }));
  };

  const submit = async () => {
    let amountAnswers = 0;
    values(answers).map((item) => {
      if (item) {
        amountAnswers = amountAnswers + 1;
      }
    });

    const payload = {
      email: userDetails.email,
      fullName: userDetails.fullName,
      amountAnswers: amountAnswers,
    };
    // console.log({ payload });

    const response = await subscribeContact(payload);
    // console.log({ response });

    if (response && response.data && response.data.success) {
      setIsOpenDialog(true);
      setIsResponseFromServer(true);
      // remove form
      setCleanForm(true);
    } else {
      setIsOpenDialog(true);
      setIsResponseFromServer(false);
      setCleanForm(true);
    }

  };

  return (
    <>
      <Container>
        <Card>
          <Img src={cover} alt="cover" />
              <Typography align="right" variant="h5">
             ניפגש במבצע הבא!
              </Typography>
        </Card>

        {/*<Card className={classes.card}>*/}
        {/*  <div>*/}
        {/*    <Typography align="right" variant="h5">*/}
        {/*      מבצע יומולדת*/}
        {/*    </Typography>*/}
        {/*    <Typography align="right" variant="body1">*/}
        {/*      כל תשובה מוסיפה לך 9% הנחה - עד 27%*/}
        {/*    </Typography>*/}
        {/*    <Typography align="right" variant="body1">*/}
        {/*      הקופון נשלח ישירות למייל שלך*/}
        {/*    </Typography>*/}
        {/*    <FullNameAndEmail*/}
        {/*      onChangeValidate={() => {}}*/}
        {/*      onChange={setUserDetails}*/}
        {/*      cleanValues={cleanForm}*/}
        {/*      setCleanValues={setCleanForm}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</Card>*/}

        {/*{questions &&*/}
        {/*  questions.map((question) => (*/}
        {/*    <Card className={classes.card} key={question.id}>*/}
        {/*      <QuizItem*/}
        {/*        question={question}*/}
        {/*        onChange={handleChange}*/}
        {/*        cleanValue={cleanForm}*/}
        {/*        setCleanValue={setCleanForm}*/}
        {/*      />*/}
        {/*    </Card>*/}
        {/*  ))}*/}
        {/*<Button*/}
        {/*  disabled={!(userDetails && userDetails.email && userDetails.fullName)}*/}
        {/*  variant="outlined"*/}
        {/*  size="medium"*/}
        {/*  onClick={submit}*/}
        {/*>*/}
        {/*  לשלוח את התוצאה - קליק*/}
        {/*</Button>*/}
        {/*<TypographyStyled>*/}
        {/*  <Typography align="right" variant="caption">*/}
        {/*    הקופון מוגבל בזמן. אין כפל מבצעים. השתתפות במבצע מכניסה אותך אוטומטי*/}
        {/*    למועדון הלקוחות שלנו . אנחנו לא שולחים ספאם. ניתן בכל עת להתנתק*/}
        {/*    ממועדון הלקוחות. המבצע יכול להסתיים בכל עת.*/}
        {/*  </Typography>*/}
        {/*</TypographyStyled>*/}
        <Bottom>
          <Link
            underline="always"
            href="https://shaharit.co.il/contact-us"
            target="_blank"
            color="inherit"
            variant="body2"
            rel="noreferrer"
          >
            ליצירת קשר
          </Link>
          <Link
            underline="always"
            href="https://shaharit.co.il/shop"
            target="_blank"
            color="inherit"
            variant="body2"
            rel="noreferrer"
          >
            לאתר שלנו
          </Link>
        </Bottom>
        <WhatsAppClick/>
        <Link
          underline="always"
          href="https://shuvy.com"
          target="_blank"
          color="inherit"
          variant="body2"
          rel="noreferrer"
        >
          ⓒ shuvy web
        </Link>
      </Container>
      <Dialog
        title="תודה רבה!"
        isOpen={isOpenDialog}
        handleClose={() => setIsOpenDialog(false)}
      >
        <ResponseFromServer response={isResponseFromServer} />
      </Dialog>
    </>
  );
};

const Container = styled.div`
  max-width: 720px;
  padding: 15px;
`;

const Img = styled.img`
  max-width: 720px;
  width: 100%;
`;

const Bottom = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-around;
`;
const TypographyStyled = styled.div`
  margin-top: 35px;
`;

export default Home;
